import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";
import PDFview from "../../../components/PdfView";
import Modal from "react-modal";

const ProformaInvoiceList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);

  const [docurl, setDocUrl] = useState(false);
  const [profarmaInvoiceId, setProfarmaInvoiceId] = useState("");
  const { sendRequest: getprofarmaInvoice } = useHttp();

  useEffect(() => {
    getprofarmaInvoice(
      {
        url: "/api/profarmaInvoice/",
      },
      (res) => {
        if (res) {
          setData(res);
          //console.log(res);
        }
      }
    );
  }, [getprofarmaInvoice]);

  const viewPdf = (itemId) => {
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
    setProfarmaInvoiceId(itemId);
  };

  const { sendRequest: formDataDelete } = useHttp();

  const deleteHandler = (e, profarmaInvoiceId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Proforma Invoice detail?",
      onOk() {
        const data = {
          profarmaInvoiceId: profarmaInvoiceId,
        };
        //console.log(data);

        formDataDelete(
          {
            url: "/api/profarmaInvoice/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success(data);
          }
        );
      },
      onCancel() {},
    });
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    setSelectedData(data);
    //console.log(data);

    setIsModalOpen(true);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Proforma Invoice</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Proforma Invoice
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center">
                      <thead>
                        <tr>
                          <th>Issue Date</th>
                          <th>Due Date</th>
                          <th>Delivery Date</th>
                          <th>Proforma Invoice id</th>
                          <th>Sales Order No</th>
                          <th>Method of Dispatch</th>
                          <th>Customer Name</th>
                          <th>Contact Person Name</th>
                          <th>Total Order cost/Value</th>
                          <th>Type of Shipment</th>
                          <th>Incoterms® 2020 Item</th>

                          {/* <th>Edit</th> */}
                          <th>Delete</th>
                          <th>Pdf</th>
                          <th>View</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.issueDate}</td>
                                <td>{itm.dueDate}</td>
                                <td>{itm.estimatedDeliveryDate}</td>
                                <td>{itm.profarmaInvoiceNo}</td>
                                <td>{itm.salesOrderNo}</td>
                                <td>{itm.methodOfDispatch}</td>
                                <td>{itm.name}</td>
                                <td>{itm.customerContactPersonName}</td>
                                <td>{itm.consignmentTotalOrderCost}</td>
                                <td>{itm.typeOfShipment}</td>
                                <td>{itm.incoTerms2020}</td>

                                {/* <td>
                                  {itm.isGoodReciept === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => {
                                        props.update(itm);
                                        props.addForm(true);
                                      }}
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  )}
                                </td> */}
                                <td>
                                  {itm.isGoodReciept === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn"
                                      onClick={(e) =>
                                        deleteHandler(e, itm.profarmaInvoiceId)
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  )}
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() =>
                                      viewPdf(itm.profarmaInvoiceId)
                                    }
                                  >
                                    <i className="fas fa-solid fa-file"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {docurl && (
        <Modal isOpen={true} style={customModalStyles}>
          {profarmaInvoiceId && (
            <div className="row">
              <div className="col-md-11">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_BASE_URL}/api/profarmaInvoice_pdf/?profarmaInvoiceId=${profarmaInvoiceId}`,
                      "_blank"
                    )
                  }
                >
                  Download
                </button>
              </div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setDocUrl(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>
          )}
          <PDFview
            docurl={`${process.env.REACT_APP_BASE_URL}/api/profarmaInvoice_pdf/?profarmaInvoiceId=${profarmaInvoiceId}`}
          />
        </Modal>
      )}

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Proforma Invoice Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6">
                Proforma Invoice No: {selectedData.profarmaInvoiceNo}
              </p>
              <p className="col-md-6">
                Sales Order No: {selectedData.salesOrderNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Issue Date: {selectedData.issueDate}</p>
              <p className="col-md-6">Due Date : {selectedData.dueDate}</p>
            </div>
            <div className="row">
              <p className="col-md-6">Currency : {selectedData.currencyName}</p>
              <p className="col-md-6">
                Estimated Delivery Date: {selectedData.estimatedDeliveryDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Customer Name: {selectedData.name}</p>

              <p className="col-md-6">
                Contact Person Name : {selectedData.customerContactPersonName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Work Contact Number: {selectedData.workContactNumber}
              </p>
              <p className="col-md-6">
                Whatsapp Number : {selectedData.whatsappNumber}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Type of Shipment: {selectedData.workContactNumber}
              </p>
              <p className="col-md-6">
                Terms/Method of payment : {selectedData.methodOfPayment}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Port of Loading: {selectedData.workContactNumber}
              </p>
              <p className="col-md-6">
                Method of Dispatch: {selectedData.methodOfDispatch}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Incoterms® 2020: {selectedData.incoTerms2020}
              </p>
              <p className="col-md-6">
                Port of Discharge : {selectedData.portOfDischarge}
              </p>
            </div>

            <div className="row">
              <p className="col-md-12">
                Registered Address: {selectedData.registeredAddress} ,
                {selectedData.city}, {selectedData.state},{" "}
                {selectedData.country}, {selectedData.zipCode}.
              </p>
            </div>
            <h5>Bank Details</h5>
            <table className="table table-bordered table-sm text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>

                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.bankDetails &
                  selectedData.bankDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>

                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <h5>Product Details</h5>
            <table className="table table-bordered table-responsive table-sm text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>

                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                  <th>Discount</th>
                  <th>Discount Amount</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productDetails &&
                  selectedData.productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.lineSrNo}</td>

                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.salesOrderQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.subTotalAmount}</td>
                        <td>{itm.discount}</td>
                        <td>{itm.discountAmount}</td>
                        <td>{itm.totalLineAmount}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <div className="row">
              <p className="col-md-6">
                Order Total Value : {selectedData.consignmentTotalOrderCost}
              </p>
              <p className="col-md-6">Remark : {selectedData.remark}</p>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default ProformaInvoiceList;
